export default {
  namespaced: true,

  state: {
    hiddenElements: [],
    isAlertDialogOpen: false
  },

  mutations: {
    setIsAlertDialogOpen(state, value) {
      state.isAlertDialogOpen = value
    },

    setHiddenElements(state, value = []) {
      state.hiddenElements = value
    }
  },

  getters: {
    isAlertDialogOpen: state => state.isAlertDialogOpen,
    isElementHidden: state => element => state.hiddenElements.includes(element)
  }
}
